import App from "./App.svelte";
import atag from "./data/atag.js";

const app = new App({
  target: document.getElementById("conformance-tool"),
});

export default app;
